'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  'index.html': {
    content: '<div id="root"></div>'
  },
  'index.js': {
    content: '/**\n    This CodeSandbox has been automatically generated using\n    `codesandboxer`. If you\'re curious how that happened, you can\n    check out our docs here: https://github.com/codesandbox/codesandboxer\n  \n    If you experience any struggles with this sandbox, please raise an issue\n    on github. :)\n  */\n  import Vue from "vue";\n  import Example from \'./example\';\n  \n  Vue.config.productionTip = false;\n  \n  /* eslint-disable no-new */\n  new Vue({\n    el: "#root",\n    components: { Example },\n    template: "<Example/>"\n  });\n  '
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/codesandboxer/dist/templates/vue.js
// module id = 434
// module chunks = 168707334958949